import { PadBox } from '@bedrock-layout/padbox';
import styled from 'styled-components';

export const ResendEmailVerificationLinkContainer = styled(PadBox)`
  background-color: var(--color-amour);
  position: sticky;
  top: 0;
  padding: 1.3rem 0rem 1.3rem 2rem;
`;
